import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingBalloonContents = function () {
    return utilBalancing.getBalancing().BalloonOfferContents;
};
export var selectBalancingBalloonContent = memoize(function (contentId) {
    return selectBalancingBalloonContents().get(contentId);
});
export var balancingBalloonContentsMemoizedFunctions = [
    selectBalancingBalloonContents,
    selectBalancingBalloonContent,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingBalloonContents.ts
// module id = 670
// module chunks = 3